function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import "./index.less";
var Checkbox = function Checkbox(_ref) {
  var className = _ref.className,
    label = _ref.label,
    children = _ref.children,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    size = _ref.size,
    ghost = _ref.ghost;
  var _useState = useState(checked),
    _useState2 = _slicedToArray(_useState, 2),
    isCheck = _useState2[0],
    setIsCheck = _useState2[1];
  var handleCheckboxChange = function handleCheckboxChange(event) {
    setIsCheck(event.target.checked);
    if (onChange) {
      onChange(event, event.target.checked);
    }
  };
  var classes = classNames('iron-checkbox-wrapper', className, _defineProperty({}, 'iron-checkbox-disabled', disabled));
  var checkbox = classNames('iron-checkbox', _defineProperty(_defineProperty(_defineProperty({}, "iron-checkbox-".concat(size), size), 'iron-checkbox-checked', isCheck), 'iron-checkbox-ghost', ghost));
  useEffect(function () {
    setIsCheck(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement("label", {
    className: classes
  }, /*#__PURE__*/React.createElement("span", {
    className: checkbox
  }, /*#__PURE__*/React.createElement("input", {
    className: "iron-checkbox-input",
    type: "checkbox",
    checked: isCheck,
    onChange: handleCheckboxChange,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("span", {
    className: "iron-checkbox-inner animate__animated animate__pulse"
  })), children && /*#__PURE__*/React.createElement("span", {
    className: "iron-checkbox-content"
  }, children), label && /*#__PURE__*/React.createElement("span", {
    className: "iron-checkbox-label-content"
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  })));
};
Checkbox.defaultProps = {
  size: 'medium',
  labelFontSize: 'medium',
  disabled: false,
  onChange: undefined,
  checked: false,
  icon: 'icon-tick'
};
export default Checkbox;